<template>
	<div class="myCard l">
		<div class="top"><img src="../../../assets/img/card.png" alt="" /><p>我是小小的太阳 </p><span>加入微信关注：</span></div>
		<p class="under"><img src="../../../assets/img/card1.png"/>扫一扫，进入商城</p>
	</div>
</template>

<script>
export default {
  data () {
    return {
      
    }
  },
  created () {
  },
  methods: {
   
  }
}
</script>

<style lang="less" scoped>
	.l{float: left;}
	.r{float: right;}
	.center {width: 1200px;margin: 0 auto;height: 100%;}
	.myCard{
			width:980px;background: #fff;margin:16px 0;padding-bottom:40px;height:384px;
			.top{height:102px;border-bottom:1px solid #e8e8e8;img{float:left;margin:10px 14px 0 12px;}p{font-size:14px;color:#333;margin-top:33px;float:left;;width:70%;}span{display:inline-block;font-size:14px;color:#cd2a2c;width:70%;}}
			.under{width:136px;height:170px;text-align: center;font-size:14px;margin:43px auto 0; img{float:left;margin-bottom:10px;}}
		}
</style>